
import moment from "moment-timezone"
import hash from "object-hash"

const Mixins = {}

/**
 * Auto saving to local storage
 */
Mixins['autosave'] = {
    created() {
        this.initialVueData = JSON.parse(JSON.stringify(this.$data))
    },
    activated: function () {

        // window.autosave = this.window = {}

        const key = location.pathname.replace(/\//ig, '-').replace(/-/, '')
        window.backupKey = this.backupKey = `tab-backup-${key}`

        // Auto Saving
        clearInterval(window.autoSaveState)
        window.autoSaveState = setInterval(this.saveBackupData, 15000)

        // Saving
        window.saveBackupData = this.saveBackupData

        // Loading
        window.loadBackupData = this.loadBackupData

        // Clearing
        window.clearTabData = this.clearData
        window.clearBackups = this.clearBackups

        window.currentTabData = this.$data
        window.restoreBackupData = this.restoreBackupData
    },
    methods: {
        clearData() {
            Object.assign(this.$data, this.initialVueData)
        },

        saveBackupData() {
            const store = window.localStorage
            const data = this.$data

            // With history
            let dataHistory = []

            let currentData = this.loadBackupData()
            if (!currentData) currentData = []

            let latestSave = currentData[currentData.length - 1]
            let newSnapshot = { date: moment().format(), data }

            // If current data is same as latest save, don't save
            if (typeof latestSave === 'object' && (hash(latestSave.data) === hash(newSnapshot.data))) return false

            // Limit save history
            if (currentData.length >= 100) currentData.splice(0, 10)

            // Join history to new data
            if (Array.isArray(currentData)) {
                dataHistory = dataHistory.concat(currentData)
            }

            dataHistory.push(newSnapshot)
            const dataStr = JSON.stringify(dataHistory)

            try {
                store.setItem(window.backupKey, dataStr)
            } catch (e) {

                this.clearBackups()
            }
        },

        // Save based on inputs
        getInputsData() {
            const data = {}
            $('.input-belt').each(function () {
                const label = $(this).find('label').text().trim().replace(/[\W_]+/g, ' ')
                const val = $(this).find('input').val()
                try {
                    if (label.length > 0 && val.length > 0) {
                        data[label] = val
                    }
                } catch (e) {
                    //
                }
            })
            return data
        },

        loadBackupData() {
            const store = window.localStorage
            const data = JSON.parse(store.getItem(window.backupKey) || null)
            return data
        },

        clearBackups() {
            window.localStorage.removeItem(window.backupKey)
        },

        restoreBackupData(savedData) {
            const $data = savedData.data
            Object.assign(this.$data, $data)
        }
    }
}

/**
 * Show a warning on reload with unsaved changes
 */
Mixins['unsavedWarning'] = {
    activated() {
        window.onbeforeunload = (e) => {
            if (!this.saved) {
                // Cancel the event
                e.preventDefault()
                // Chrome requires returnValue to be set
                e.returnValue = ''
            }
        }
    },
    deactivated() {
    }
}

export default Mixins
